var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 15 8.149 C 9.775 12.500, 4.386 17.170, 3.025 18.527 C 0.552 20.994, 0.552 20.996, 2.547 22.991 C 4.542 24.987, 4.549 24.983, 14.361 16.494 C 19.761 11.822, 24.341 8, 24.538 8 C 24.736 8, 29.294 11.811, 34.668 16.469 L 44.438 24.938 46.666 22.845 L 48.894 20.751 41.660 14.626 C 37.682 11.257, 32.193 6.641, 29.463 4.369 L 24.500 0.238 15 8.149 M 15.250 22.602 L 7 30.172 7 39.586 L 7 49 12.445 49 L 17.890 49 18.195 44.250 L 18.500 39.500 24.193 39.202 L 29.886 38.904 30.193 43.702 L 30.500 48.500 36.750 48.798 L 43 49.095 42.960 39.798 L 42.919 30.500 34.062 22.750 C 29.190 18.487, 24.821 15.007, 24.352 15.016 C 23.883 15.024, 19.788 18.438, 15.250 22.602",
    stroke: "none",
    fill: "#ffffff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.81b227116e9eca9c7a6335981fc8bb90.svg";
export { ForwardRef as ReactComponent };